import React, { useEffect } from 'react'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import Form from '../../../../components/Form'
import Assignees from '../../../../components/Form/Items/Assignees'
import Attachments from '../../../../components/Form/Items/Attachment'
import Deadline from '../../../../components/Form/Items/Deadline'
import Description from '../../../../components/Form/Items/Description'
import FolderSelector from '../../../../components/Form/Items/FolderSelector'
import Mandatory from '../../../../components/Form/Items/Mandatory'
import AdditionalSigner from '../../../../components/Form/Items/Signature/AdditionalSigner'
import Title from '../../../../components/Form/Items/Title'
import SignDocuments from './SignDocuments'

const Content = () => {
  const { form, initializeForm } = useFormProvider()

  useEffect(() => {
    initializeForm(TaskConfigurationTypes.SignDocuments)
  }, [])

  if (!form) return null
  return (
    <Form
      items={{
        title: <Title />,
        assignees: <Assignees />,
        signDocuments: <SignDocuments />,
        folder: <FolderSelector />,
        additionalSigner: <AdditionalSigner />,
        description: <Description />,
        deadline: <Deadline />,
        attachments: <Attachments />,
        mandatory: <Mandatory />,
      }}
    />
  )
}

export default Content
